<template>
  <transition name="popup">
    <div class="inspector-frame">
      <draggable class="frame" :x="x" :y="y">
        <faicon v-if="!force" @click="$emit('close')" class="close" icon="times-circle" />
        <slot />
      </draggable>
    </div>
  </transition>
</template>

<script>
import draggable from '../common/draggable'
export default {
  props: {
    x: Number,
    y: Number,
    force: Boolean
  },
  components: { draggable }
}
</script>

<style scoped>
.inspector-frame {
  position: absolute;
  top: 50%;
  left: 50%;
  /* z-index: 2; */
  width: 0;
  height: 0;
}
.frame {
  display: flex;
  flex-flow: column;
  background-color: #30353E;
  color: #fff;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.8);
}
.close {
  padding: 5px 5px 2px 2px;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  cursor: pointer;
  filter: drop-shadow(0 0 1px rgba(0, 0, 0, 0.2));
}
.popup-enter-active, .popup-leave-active {
  transform: scale(1);
  transition: all 300ms cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
.popup-enter, .popup-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: scale(0.9);
}
</style>